export default __webpack_public_path__ + "static/media/NeologicaLogo.91edc0cd.svg";